<template>
  <div>
    <app-title>Partner Details</app-title>
    <v-container fluid>
      <v-row>
        <v-col
          >Start Date:
          <date-picker
            v-model="startDate"
            lang="en-au"
            name="startDate"
            format="DD/MM/YYYY"
            placeholder="dd/MM/YYYY"
          ></date-picker>
        </v-col>

        <v-col
          >End Date:
          <date-picker
            v-model="endDate"
            lang="en-au"
            name="endDate"
            format="DD/MM/YYYY"
            placeholder="dd/MM/YYYY"
          ></date-picker>
        </v-col>

        <v-col>
          <v-btn color="success" @click="refresh(`details`)"
            >Refresh Details</v-btn
          >
        </v-col>
      </v-row>

      <v-row v-if="headers">
        <v-col cols="12">
          <list-details
            :items="details"
            title="Partner Details"
            :headers="headers"
          ></list-details>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import listDetails from "@/components/channelPartners/list-details";
import { createNamespacedHelpers } from "vuex";
const { mapActions: mapPartnerActions } = createNamespacedHelpers("partner");

export default {
  name: "PartnerDetails",
  components: { listDetails },
  data() {
    return {
      menu1: false,
      menu2: false,
      startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1)
        .toISOString()
        .substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      details: []
    };
  },
  computed: {
    headers() {
      if (this.details.length > 0) return this.getHeaders(this.details[0]);
      else return null;
    }
  },
  methods: {
    ...mapPartnerActions(["getPartnerData"]),
    refresh(option) {
      let vm = this;
      vm.label = option;
      let url = null;
      switch (option.toString().toLowerCase()) {
        case "details":
          url = `dealerPortal/ListChannelPartnerDetails`;
          break;

        default:
          break;
      }
      vm.getPartnerData({
        startDate: vm.startDate,
        endDate: vm.endDate,
        url: url
      })
        .then(data => {
          vm.details = data;
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped></style>
